/* ============ HERO LIGHT — two-tier raking-light hero effect ============
 * Tier 1 (always on, zero JS required): a real <img> plus a CSS
 * radial-gradient overlay (see hero.css .hero__glow), art-directed at fixed
 * coordinates with mix-blend-mode: soft-light, and a bottom scrim for
 * headline legibility. This ships to every visitor, including those with
 * prefers-reduced-motion or no WebGL2 — it needs nothing from this file.
 *
 * Tier 2 (progressive enhancement, this module): a WebGL2 canvas that
 * computes a per-pixel pseudo-normal from the hero photo's own luminance and
 * renders a pointer-reactive Blinn-Phong specular highlight. Only
 * initialized when motion is allowed AND a WebGL2 context is obtainable —
 * the shader module itself (hero-shader.js) is dynamically import()ed so its
 * code, and the cost of compiling/running the shader pipeline, never ships
 * to visitors who don't qualify for it.
 */

function initHeroLight() {
  const hero = document.querySelector('.hero');
  if (!hero) return; // No-op on pages without a hero (every page but home in Phase 2).

  const img = hero.querySelector('.hero__img');
  const canvas = hero.querySelector('.hero__canvas');
  if (!img || !canvas) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // CSS fallback (hero.css .hero__glow) only.
  }

  let supportsWebGL2 = false;
  try {
    supportsWebGL2 = !!document.createElement('canvas').getContext('webgl2');
  } catch (err) {
    supportsWebGL2 = false;
  }
  if (!supportsWebGL2) return; // CSS fallback only.

  const shaderSrc = canvas.dataset.shaderSrc;
  if (!shaderSrc) return;

  import(shaderSrc)
    .then((mod) => {
      if (mod && typeof mod.initHeroShader === 'function') {
        mod.initHeroShader({ hero, img, canvas });
      }
    })
    .catch(() => {
      // Network failure or shader compile error inside hero-shader.js — the
      // CSS fallback stays visible (canvas remains opacity:0). Fail silently
      // rather than surface a broken canvas or throw in the console.
    });
}

export { initHeroLight };
